import { useFormModalContext } from '@context/FormModalContext'
import Hero from '@global/Blocks/Hero'
import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'
import dynamic from 'next/dynamic'
import React from 'react'

const CareerRegisterForm = dynamic(
  () => import('@global/Form/CareerRegisterForm'),
  {
    ssr: false,
  }
)

const CareersLandingPage = (props) => {
  const { setShowFormModal } = useFormModalContext()
  const {
    title,
    // Verified on GET /api/cms/pages/1972/ → h1_heading
    h1_heading,
    hero_image,
    content_blocks,
    hero_image_anchor,
    hero_call_to_action_label,
    hero_call_to_action_link,
  } = props.pageData

  const pageH1 =
    typeof h1_heading === 'string' ? h1_heading.trim() : ''

  // Handle View Positions
  content_blocks.forEach((it) => {
    if (it.type === 'centered_image_and_text') {
      if (it.value.call_to_action_text === 'View Positions Available') {
        it.value.call_to_action_click = () => {
          const elm = document.getElementById('vacant-showcase')
          elm.scrollIntoView({ behavior: 'smooth' })
        }
      }
      if (it.value.call_to_action_text === 'Register Interest') {
        it.value.call_to_action_click = () => {
          setShowFormModal(true)
        }
      }
    }
  })

  return (
    <React.Fragment>
      <Hero
        title={title}
        titleAs={pageH1 ? 'div' : 'h1'}
        pageH1={pageH1 || undefined}
        bgImageUrl={hero_image.url}
        bgPosition={hero_image_anchor}
        callToAction={{
          label: hero_call_to_action_label,
          link: hero_call_to_action_link,
        }}
      />
      <CareerRegisterForm />
      <WagtailBlocksSection blocks={content_blocks} />
    </React.Fragment>
  )
}

export default CareersLandingPage
